//src/graphql

import gql from "graphql-tag";

const segmentsUpdateSubscribeQuery = gql`
subscription segmentsUpdateSubscribe {
  onUpdateConnect2WalletSegment {
      __typename
      id
      errorMessage
      generateTechsStatus
      tech_generation_info
      isLocked
  }
}
`;

export default segmentsUpdateSubscribeQuery;
